"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function moduleDecoratorFactory(modOrOpt) {
    return function (constructor) {
        var module = constructor;
        var stateFactory = function () {
            var state = new (module.prototype.constructor)({});
            var s = {};
            Object.keys(state).forEach(function (key) {
                if (state.hasOwnProperty(key)) {
                    if (typeof state[key] !== 'function') {
                        s[key] = state[key];
                    }
                }
            });
            return s;
        };
        if (!module.state) {
            module.state = (modOrOpt && modOrOpt.stateFactory) ? stateFactory : stateFactory();
        }
        if (!module.getters) {
            module.getters = {};
        }
        module.namespaced = modOrOpt && modOrOpt.namespaced;
        Object.getOwnPropertyNames(module.prototype).forEach(function (funcName) {
            var descriptor = Object.getOwnPropertyDescriptor(module.prototype, funcName);
            if (descriptor.get) {
                module.getters[funcName] = function (moduleState) { return descriptor.get.call(moduleState); };
            }
        });
        if (modOrOpt.dynamic) {
            var modOpt = modOrOpt;
            modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
            module);
        }
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}
exports.Module = Module;
//# sourceMappingURL=module.js.map